// extracted by mini-css-extract-plugin
module.exports = {"title":"BooksetList__title"};